// Authentication related pages
import Login2 from "../pages/Authentication/Login2.svelte";

// Dashboard
import Dashboard from "../pages/Dashboard/index.svelte";
import AlertsPage from "../pages/Ecommerce/EcommerceOrders/alerts.svelte";
import IconBoxicons from "../pages/Icons/IconBoxicons.svelte";
import IconDripicons from "../pages/Icons/IconDripicons.svelte";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign.svelte";
import IconFontawesome from "../pages/Icons/IconFontawesome.svelte";
import Recoverpw from "../pages/Authentication/Recoverpw.svelte";
import LockScreen from "../pages/Authentication/auth-lock-screen.svelte";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile.svelte";
import RecoveryPasswordConfirmation from "../pages/Authentication/recovery-password-confirmation.svelte";
import StackedColumnChart from "../pages/Dashboard/StackedColumnChart.svelte";
import menuTankOption from "../pages/Dashboard/menuTankOption.svelte";
import menuDestinationChart from "../pages/Dashboard/menuDestinationChart.svelte";
import menuDeviceChart from "../pages/Dashboard/menuDeviceChart.svelte";
import menuTrucksChart from "../pages/Dashboard/menuTrucksChart.svelte";
import menuCompanyChart from "../pages/Dashboard/menuCompanyChart.svelte";
import Pages500 from "../pages/Authentication/pages-500.svelte";

const authProtectedRoutes = [
  { path: "/", component: Dashboard },
  { path: "/alert", component: AlertsPage },
  { path: "/contacts-profile", component: ContactsProfile },
  { path: "/tanque-proceso", component: menuTankOption },
  { path: "/origen", component: StackedColumnChart },
  { path: "/destinos", component: menuDestinationChart },
  { path: "/dispositivo", component: menuDeviceChart },
  { path: "/camion", component: menuTrucksChart },
  { path: "/compania", component: menuCompanyChart },
  
  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },
];

const publicRoutes = [
  { path: "/login", component: Login2 },
  { path: "/auth-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/recovery-password-confirmation", component: RecoveryPasswordConfirmation },
  { path: "/500", component: Pages500 },
  { path: "*", component: Login2 } // Ruta por defecto para cualquier otra ruta no definida
];

const MOCK_DATA = {
  authProtectedRoutes,
  publicRoutes,
};

export default MOCK_DATA;